import { Phone } from "lucide-react";

export function QuoteCTA({ title = "Get Your Free Quote Today", subtitle }: { title?: string; subtitle?: string }) {
  return (
    <section className="relative overflow-hidden bg-hero-gradient py-20 text-white">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 20% 50%, white 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
      <div className="relative mx-auto max-w-4xl px-4 text-center lg:px-8">
        <div className="mb-4 inline-block bg-red px-4 py-1 font-display text-xs tracking-[0.3em]">★ CUSTOM BUILT TEXAS ★</div>
        <h3 className="font-display text-4xl font-bold md:text-6xl">{title}</h3>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-white/85">
          {subtitle ?? "Awnings, covers, curtains, sail shades, aluminum welding & custom fabrication — designed, built, and installed across Central Texas, South Texas, and the Gulf Coast."}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <a href="tel:+18303909588" className="inline-flex items-center gap-3 bg-red px-8 py-4 font-display text-base uppercase tracking-wider text-white shadow-bold transition hover:bg-red-deep">
            <Phone className="h-5 w-5" /> Call +1 (830) 390-9588
          </a>
          <a href="mailto:office@texasmadeshade.com" className="inline-flex items-center gap-3 border-2 border-white px-8 py-4 font-display text-base uppercase tracking-wider text-white transition hover:bg-white hover:text-navy-deep">
            office@texasmadeshade.com
          </a>
        </div>
      </div>
    </section>
  );
}
